<template>
  <div class="flex flex-col space-y-2" id="selectlist">
    <div
      v-for="option in options"
      :key="option.id"
      class="uppercase font-heading font-semibold px-4 py-2 text-center border rounded-md border-linear-subtle cursor-pointer option"
      :class="{
        'bg-surface-inverse text-fg-inverse': option.id === value.id,
        'bg-surface-primary text-fg-secondary': option.id !== value.id,
      }"
      @click="selectItem(option)"
    >
      {{ option[itemText] }}
    </div>
  </div>
</template>

<script lang="ts">
import { PropType, defineComponent } from 'vue'

export default defineComponent({
  name: 'SelectList',
  model: {
    prop: 'value',
    event: 'change',
  },
  props: {
    value: { type: Object, required: true },
    options: { type: Array as PropType<{ id: number }[]>, required: true },
    itemText: { type: String, required: false, default: 'id' },
  },
  methods: {
    selectItem(item) {
      this.$emit('change', item)
    },
  },
})
</script>
